import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTopButton from './ScrollToTopButton';

const backLinkClass =
  'inline-flex items-center rounded-full border border-[rgba(74,33,71,0.1)] bg-white px-5 py-2.5 font-jakarta text-sm font-semibold text-[#2a0f2a] transition-colors hover:border-chisme-primary/30 hover:text-chisme-primary';

const proseClass =
  'space-y-4 font-jakarta text-base leading-relaxed text-[#5a3158] [&_h2]:mt-8 [&_h2]:font-jakarta [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-[#2a0f2a] [&_h2:first-child]:mt-0 [&_h3]:mt-5 [&_h3]:font-jakarta [&_h3]:font-bold [&_h3]:text-[#2a0f2a] [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-5 [&_a]:font-medium [&_a]:text-chisme-primary [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-chisme-primary/85';

type LegalPageShellProps = {
  backLabel: string;
  title: string;
  lastUpdatedLabel: string;
  lastUpdatedDate: string;
  children: React.ReactNode;
};

const LegalPageShell: React.FC<LegalPageShellProps> = ({
  backLabel,
  title,
  lastUpdatedLabel,
  lastUpdatedDate,
  children,
}) => {
  return (
    <>
      <div className="container-chisme py-10 lg:py-16">
        <Link to="/" className={backLinkClass}>
          {backLabel}
        </Link>

        <article className="mx-auto mt-8 max-w-3xl rounded-3xl border border-[rgba(74,33,71,0.1)] bg-white px-6 py-8 sm:px-10 sm:py-10">
          <header className="mb-8 border-b border-[rgba(74,33,71,0.1)] pb-6">
            <h1 className="font-instrument text-3xl leading-tight tracking-[-0.02em] text-[#2a0f2a] sm:text-4xl md:text-5xl">
              {title}
            </h1>
            <p className="mt-3 font-jetbrains text-[11px] uppercase tracking-[0.12em] text-[#5a3158]">
              <span className="font-semibold">{lastUpdatedLabel}</span> {lastUpdatedDate}
            </p>
          </header>

          <div className={proseClass}>{children}</div>
        </article>
      </div>
      <ScrollToTopButton />
    </>
  );
};

export default LegalPageShell;
